module.exports = __webpack_public_path__ + "img/1 (97).f7f0bfbf.png";